import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { defaultDataAcessor } from 'src/app/core/helpers/mat-sort-data-accessor';

@Component({
  selector: 'app-modal-selecionar-ug',
  templateUrl: './modal-selecionar-ug.component.html',
  styleUrls: ['./modal-selecionar-ug.component.scss']
})
export class ModalSelecionarUgComponent implements OnInit {
  public dataSource = new MatTableDataSource<any>([]);
  public semDados = false;
  public displayedColumns = ['selecao', 'id', 'ug'];
  public elementosSelecionados = false;
  public modoSelecaoUnica = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private dialogRef: MatDialogRef<ModalSelecionarUgComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

	this.modoSelecaoUnica = !!data?.params;
    this.dataSource = new MatTableDataSource<any>(data?.params ? data.data : data);
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data: { nome : string, sigla: string }, filterValue: string) => {
      return (data.sigla || '').trim().toLowerCase().indexOf(filterValue) !== -1 || (data.nome || '').trim().toLowerCase().indexOf(filterValue) !== -1;
    };
    this.dataSource.sortingDataAccessor = defaultDataAcessor;
    this.dataSource._updateChangeSubscription();
    this.semDados = this.dataSource.filteredData.length === 0;
  }

  public filtrar(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.semDados = this.dataSource.filteredData.length === 0;
  }

	onItemSelecionado(selecionado: boolean, elemento: any): void {
		if (this.modoSelecaoUnica) {
			this.dataSource.data.forEach(item => item.selecionado = false);
		}

		elemento.selecionado = selecionado;
	}

  public selecionarTodos() {
    this.dataSource.data.forEach(d => d.selecionado = !this.elementosSelecionados);
    this.elementosSelecionados = !this.elementosSelecionados;
  }

  public concluir() {
    this.dialogRef.close(this.dataSource.data.filter(d => d.selecionado));
  }

  public cancelar() {
    this.dialogRef.close();
  }
}

